import styled from 'styled-components'

import { helpers } from 'styles'

import { Container } from './Container'

export const ChevronWrapper = styled.div`
	opacity: 0;
	visibility: hidden;
	transition: transform 200ms ease, opacity 200ms ease, visibility 200ms ease;
	display: flex;
	align-items: center;
	color: ${helpers.color.textMuted};
	transform: translate(-10px, 0);

	&:hover,
	${Container}:hover & {
		opacity: 1;
		visibility: visible;
		transform: translate(-6px, 0);
	}

	> svg {
		margin-bottom: -1px;
	}
`
